<template>
<div>
  <h-section-header back="/dashboard">
    <div class="row full-width space-between">
      <div>{{client.first_name}}'s settings</div>
      <button v-if="!clientProfile.deactivated" @click="displayDeactivate=true">Deactivate</button>
      <button v-if="clientProfile.deactivated" @click="reActivate()">Activate</button>
    </div>
  </h-section-header>
  <div class="card card--transparent">
    <div class="card--container">
      <form @submit.prevent="save">
        <h-input type="text" label="First Name" v-model="client.first_name"></h-input>
        <h-input type="text" label="Last Name" v-model="client.last_name"></h-input>
        <h-input type="text" label="Email" v-model="client.email"></h-input>
        <clientProfileForm :profile="clientProfile" @error="val => profileError = val" />
        <h-select 
          label="Habit Program" 
          v-if="clientProfile.allow_daily_exercises && habitPrograms.length"
          v-model="clientProfile.theme"
          :items="habitPrograms"
          item-text="name"
          item-value="id"></h-select>
      
        <h-select
          label="Pulse Survey"
          v-model="clientProfile.assigned_pulse_survey"
          :items="pulseSurveys"
          v-if="clientProfile.id && clientProfile.allow_self_reflect && pulseSurveys.length"
          item-text="name"
          item-value="id" />
        <div class="error-msg" v-if="error">
          {{error}}
        </div>
        <button :disabled="error || profileError" type="submit" class="btn btn--outline btn--full">Save</button>
      </form>
    </div>
  </div>
  <modal 
    @close="displayDeactivate = false" 
    @submit="deactivate"
    title="Are you sure?" 
    btn="Deactivate"
    v-if="displayDeactivate">
    <div>
      Are you sure you want to deactivate {{client.first_name}}.
      Doing so will prohibit the user from using the system.
    </div>
  </modal>
</div>

</template>

<script>
import store from "@/services/api/store";
import modal from "@/components/modal/default";
import snackbar from "@/services/hubs/snackbar";
import clientProfileForm from "../../components/clients/clientProfileForm"

export default {
  components: { modal, clientProfileForm },
  props: ["client"],
  data() {
    return {
      habitPrograms: [],
      courses: [],
      clientProfile: {},
      pulseSurveys: [],
      displayDeactivate: false,
      profileError: false
    };
  },
  created() {
    store
      .find("CoachClientProfile", this.client.client_profile)
      .then(profile => {
        this.clientProfile = profile;
      });
    
    store.findAll("CoachHabitPrograms", {}, { force: true })
      .then((h) => {
        this.habitPrograms = h;
      })
    
    store.findAll("CoachPulseSurveys")
      .then(s => {
        this.pulseSurveys = s;
      })
  },
  computed: {
    error() {
      if (this.clientProfile.allow_daily_exercises && !this.clientProfile.theme) {
        return "You must select a Habit Program";
      }
      if (this.clientProfile.allow_self_reflect && !this.clientProfile.assigned_pulse_survey) {
        return "You must select a Pulse Survey";
      }
      return undefined
    }
  },
  methods: {
    reActivate() {
      this.clientProfile.deactivated = null;
      this.clientProfile.save();
      snackbar.update("This user has been turned back on");

    },
    deactivate() {
      this.clientProfile.destroy();
      snackbar.update("Deactivated");
      this.$router.push("/dashboard?force=true");
    },
    save() {
      let clientData = {
        email: this.client.email,
        first_name: this.client.first_name,
        last_name: this.client.last_name,
      }
      store.update("CoachClients", this.client.id, clientData, {method: 'patch'})
      this.clientProfile.save();
      snackbar.update("Saved");
    }
  }
};
</script>

<style>

</style>
